import script from "./WXTips.vue?vue&type=script&setup=true&lang=ts"
export * from "./WXTips.vue?vue&type=script&setup=true&lang=ts"

import "./WXTips.vue?vue&type=style&index=0&id=bef476de&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bef476de"]])

export default __exports__